// Create a new watcher to look for elements that should or should not be focusable
const FocusWatcher = new Watcher({
  attributes: true
});

// When the watcher updates
FocusWatcher.on('update', containers => {
  containers.forEach(container => {
    // Check to see if the elements should be focusable using the aria-hidden attribute on the container
    const hidden = container.getAttribute('aria-hidden') === 'true';
    // Get all the focusable elements in the container
    const focusable = [...container.querySelectorAll('a, button, input, select, textarea, [tabindex]')];

    // Loop through all the focusable elements
    focusable.forEach(el => {
      // If the container is hidden, set the tabindex to -1 otherwise set it to 0
      el.setAttribute('tabindex', hidden ? -1 : 0);
    });
  });
});

// Watch for changes to the aria-hidden attribute
FocusWatcher.watch('[aria-hidden]');